<section [ngStyle]="{ height: height }" class="scroll">
  <div class="ssc ssc-card" *ngFor="let item of placeholderArray">
    <div class="ssc-wrapper">
      <div [ngStyle]="cssClass">
        <div class="content-center main-column pl-16 pr-16">
          <div class="content-center">
            <div class="ssc-circle"></div>
          </div>
          <div>
            <div class="content-center line-container m-0">
              <div class="ssc-line content-center"></div>
              <div class="ssc-line content-center"></div>
            </div>
          </div>
        </div>
        <div
          class="pl-16 pr-16 line-container content-center w-75"
          *ngFor="let item of columnsToRender"
        >
          <div class="ssc-line content-center"></div>
        </div>
      </div>
    </div>
  </div>
</section>
